export default {
    en: {
        dashboard : "Dashboard",
        logout    : "Logout",
        users     : "Users",
        my_profile: "My Profile"
    },
    el: {
        dashboard : "Πίνακας Ελέγχου",
        logout    : "Αποσύνδεση",
        users     : "Χρήστες",
        my_profile: "Το Προφίλ Μου"
    }
};